// extracted by mini-css-extract-plugin
export default {"container":"BMl0","blockHeader":"aYfV","btn":"e_9v","btnTitle":"q2it","btnLoader":"mImj"};